import React, { useEffect, useState } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from './header';
import Banner from './banner';
import Experience from './experience';
import Footer from './footer';
import Reviews from './reviews';
import WorkWithUs from './workwithus';
import ScrollSpy from 'react-ui-scrollspy';
import WebModal from './common/web-modal';
import Growth from './growth';
import ReletedServices from './relatedServices';
import Development from './development';

export default function DesktopLayout() {
  const [webModal, setWebModal] = useState(false);
  const [customHeading, setCustomHeading] = useState("default");

  const toggleWebModal = (heading) => {
    setCustomHeading(heading || "default");
    setWebModal(!webModal);
  };
 
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
      mirror: false,
      offset: 100,
      anchorPlacement: 'top-bottom',
      disable: 'mobile'
    });    
  }, []);
  return (
    <>
    <Header toggleModal={() => toggleWebModal("default")} />
    <WebModal modal={webModal} toggleModal={() => toggleWebModal(customHeading)} customHeading={customHeading} />
    <ScrollSpy scrollThrottle={100} useBoxMethod={false}>
      <Banner id="banner" toggleModal={() => toggleWebModal("default")} />
      <Experience toggleModal={() => toggleWebModal("default")} />
      <Growth toggleModal={() => toggleWebModal("default")} />
      <Development toggleModal={()=> toggleWebModal("default")}/>    
      <Reviews id="review"/>
      <ReletedServices />
      <WorkWithUs /> 
    </ScrollSpy>
    <Footer />
  </>
  )
}